export default __webpack_public_path__ + "static/media/DSC_0709.9bd315ee.JPG";